var _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLedEmailIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 163,
    height: 163,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M142.625 61.125v61.125a20.374 20.374 0 01-20.375 20.375H33.958a20.375 20.375 0 01-20.374-20.375V61.125c0-7.539 4.095-14.127 10.187-17.645l-.02-.027 54.34-31.377 54.381 31.397-.007.02a20.372 20.372 0 0110.16 17.632zM25.245 50.707l52.86 34.325 52.859-34.325L78.091 19.92 25.245 50.707zm52.86 42.42l-56.82-36.892a13.549 13.549 0 00-.91 4.89v61.125a13.586 13.586 0 0013.584 13.583h88.291a13.583 13.583 0 0013.583-13.583V61.125c0-1.725-.319-3.376-.91-4.89L78.104 93.121v.006z",
    fill: "#FFA700"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.219 50.711l52.659 35.015 53.126-35.015H25.219z",
    fill: "#C78200"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.355 50.711l52.892-32.6 53.36 32.6H25.356zM19.319 53.126l59.163 40.035-59.163 32.409V53.126z",
    fill: "#FFA700"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M136.436 53.126l-70.03 39.368 70.031 31.869-.001-71.237z",
    fill: "#FFA700"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.757 26.368l1.798 31.161 41.538 27.567 41.161-26.967.599-31.761H34.757z",
    fill: "#fff",
    stroke: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.319 124.363l53.304-28.284a12.5 12.5 0 0111.718 0l53.304 28.284c0 6.668-5.406 12.074-12.074 12.074H31.393c-6.668 0-12.074-5.406-12.074-12.074z",
    fill: "#E79700"
  })));
}

export default SvgLedEmailIcon;